import { useGameSocket } from './hooks/useGameSocket';
import { usePhase } from './store/gameStore';
import Lobby from './Lobby';
import Game from './Game';
import SeoFooter from './components/SeoFooter';
import { EtooLogo } from './components/EtooLogo';

export default function App() {
  const socket = useGameSocket();
  const phase = usePhase();

  return (
    <>
      <div className="pt-10">
        {phase === 'lobby' ? <Lobby socket={socket} /> : <Game socket={socket} />}
      </div>
      <EtooLogo />
      <SeoFooter />
    </>
  );
}